import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ITimestampsState {
    authenticatedUser: number;
    confirmedReceipts: number;
    currencies: number;
    expenses: number;
    image: number;
    offCanvas: number;
    pettyCash: number;
    preline: number;
    selectedNavDate: number;
    transactionDate: number;
    yachtCrew: number;
    yachtCrewCards: number;
};

const initialState: ITimestampsState = {
    authenticatedUser: Date.now(),
    confirmedReceipts: Date.now(),
    currencies: Date.now(),
    expenses: Date.now(),
    image: Date.now(),
    offCanvas: Date.now(),
    pettyCash: Date.now(),
    preline: Date.now(),
    selectedNavDate: Date.now(),
    transactionDate: Date.now(),
    yachtCrew: Date.now(),
    yachtCrewCards: Date.now(),
};

export const tsSlice = createSlice({
    name: 'selectedYacht',
    initialState,
    reducers: {
        reloadAuthenticatedUser: (state) => {
            state.authenticatedUser = Date.now();
        },
        reloadConfirmedReceipts: (state) => {
            state.confirmedReceipts = Date.now();
        },
        reloadCurrencies: (state) => {
            state.currencies = Date.now();
        },
        reloadExpenses: (state) => {
            state.expenses = Date.now();
        },
        reloadImage: (state) => {
            state.image = Date.now();
        },
        reloadOffCanvas: (state) => {
            state.offCanvas = Date.now();
        },
        reloadPettyCash: (state) => {
            state.pettyCash = Date.now();
        },
        reloadPreline: (state) => {
            state.preline = Date.now();
        },
        reloadSelectedNavDate: (state) => {
            state.selectedNavDate = Date.now();
        },
        reloadTransactionDate: (state) => {
            state.transactionDate = Date.now();
        },
        reloadYachtCrew: (state) => {
            state.yachtCrew = Date.now();
        },
        reloadYachtCrewCards: (state) => {
            state.yachtCrewCards = Date.now();
        },
    },
});

export const { reloadAuthenticatedUser, reloadExpenses, reloadOffCanvas, reloadPettyCash, reloadPreline, reloadSelectedNavDate, reloadTransactionDate, reloadYachtCrew, reloadYachtCrewCards } = tsSlice.actions;
export const lastAuthenticatedUserState = (state: RootState) => state.ts.authenticatedUser;
export const lastConfirmedReceiptsState = (state: RootState) => state.ts.confirmedReceipts;
export const lastCurrenciesState = (state: RootState) => state.ts.currencies;
export const lastExpensesState = (state: RootState) => state.ts.expenses;
export const lastImageState = (state: RootState) => state.ts.image;
export const lastOffCanvasState = (state: RootState) => state.ts.offCanvas;
export const lastPettyCashState = (state: RootState) => state.ts.pettyCash;
export const lastPrelineState = (state: RootState) => state.ts.preline;
export const lastSelectedNavState = (state: RootState) => state.ts.selectedNavDate;
export const lastTransactionDateState = (state: RootState) => state.ts.transactionDate;
export const lastYachtCrewState = (state: RootState) => state.ts.yachtCrew;
export const lastYachtCrewCardsState = (state: RootState) => state.ts.yachtCrewCards;

export default tsSlice.reducer;
